<template>
  <div class="step"
       v-on="step_block===true?null:status===1||status===3?{ click: () => changeStatus(2) }:''"
       :class="step_block===true?'status-unavailable':status===1?'status-empty':status===2?'status-active':status===3?'status-success-repeat':''"
  >
  <!--Preview-->
  <div class="step__preview" v-if="status===1" :key="1">
    <div></div>
    <div class="step__preview-title">
      <div class="step__name">Invite some 5-star friends to kick off the community!</div>
    </div>
    <div class="step__preview-icon">
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="30" fill="#E7E7E7"/>
        <path d="M30 12V47" stroke="black"/>
        <path d="M47 29.5L12 29.5" stroke="black"/>
      </svg>
    </div>
  </div>
  <!--Preview-->
  <!--Form-->
  <div class="step__form" v-if="status===2" :key="2">
    <div class="step__form-title">Invite some 5-star friends!</div>
    <div class="step__form-subtitle">We want to make sure the early community only have people you like, so we will
      prioritise access for users who invited their cool friends!
    </div>
    <div class="step__form-invite-form">
      <div class="step__form-invite-form-title">
        Just copy invite link and send to your friend
      </div>
      <div class="step__form-invite-form-input">
        <v-text-field v-model="invite_link" @focus="selectText">
        </v-text-field>
      </div>
      <div class="step__form-invite-form-copy-button">
        <button @click="copyLink">
          <transition name="fade">
            <template v-if="copy_status">
              <div>
                Copied
              </div>
            </template>
          </transition>
          <template v-if="!copy_status">
            <div>
              Copy
            </div>
          </template>


          <transition name="fade">
            <template v-if="copy_status">
              <div class="check-sign check-part-1"></div>
            </template>
          </transition>
          <transition name="fade">
            <template v-if="copy_status">
              <div class="check-sign check-part-2"></div>
            </template>
          </transition>
        </button>
      </div>
    </div>
    <div class="step__form-emails" id="emails_invite">
      <template v-for="(email,i) of $v.emails.$each.$iter"
      >
        <div class="step__form-label">Your friend email</div>
        <v-text-field
            v-model.trim="emails[i]"
            :key="i"
        ></v-text-field>
        <div v-if="email.$dirty&&!email.email" class="step__form-input-error">
          Wrong type of email
        </div>
      </template>
    </div>
    <div class="step__form-button-wrap">
      <div v-if="error" class="step__form-error">{{ this.error }}</div>
      <button class="step__form-button" :class="loading?'step__form-button-loading':''" :disabled="loading"
              @click="invite()">Invite
        <div class="lds-ring" v-if="loading">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </button>
    </div>

<!--    <div class="step__form-skip-button-wrap">-->
<!--      <a class="step__form-skip-button" v-if="!(step_3_status==3&&step_4_status==3)" @click="skip">Skip if you want completed later</a>-->
<!--    </div>-->
  </div>
  <!--Form-->
  <!--Success-->
  <div class="step__preview step__preview-repeat" v-if="status===3" :key="3">
    <div></div>
    <div class="step__preview-title">
      <div class="step__name">Invite friends</div>
      <div class="step__subname">You can send more</div>
    </div>
    <div class="step__preview-icon">
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="29.5" fill="black" stroke="#FFD500"/>
        <path d="M35 19L39 23L35 27" stroke="#FFD500" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M21 29V27C21 25.9391 21.4214 24.9217 22.1716 24.1716C22.9217 23.4214 23.9391 23 25 23H39"
              stroke="#FFD500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M25 41L21 37L25 33" stroke="#FFD500" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M39 31V33C39 34.0609 38.5786 35.0783 37.8284 35.8284C37.0783 36.5786 36.0609 37 35 37H21"
              stroke="#FFD500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
    <!--Success-->
  </div>
</template>

<script>
import moment from "moment";
import {email} from 'vuelidate/lib/validators'


export default {
  name: "step2",
  data: () => ({

    copy_status: false,
    emails: [''],
    error: null,
    loading: false,
  }),
  validations: {
    emails: {
      $each: {
        email
      }
    }
  },
  computed: {
    url() {
      return this.$store.getters.url
    },
    invite_link() {
      return this.$store.getters.invite_link
    },
    status() {
      return this.$store.getters.step_2_status
    },
    step_3_status() {
      return this.$store.getters.step_3_status
    },
    step_4_status() {
      return this.$store.getters.step_4_status
    },
    step_block() {
      return this.$store.getters.step_block
    }
  },
  mounted() {
    window.addEventListener('keyup', this.invite_enter);
  },
  watch: {
    emails() {
      let empty_count = 0
      this.emails.forEach(email => {
        if (email === '') {
          empty_count += 1
        }
      })
      if (empty_count === 0) {
        this.emails.push('')
      }
      document.getElementById('emails_invite').scrollTop = 9999;
    }
  },
  methods: {
    invite_enter(e){
      if (e.keyCode === 13&&this.status===2) {
        this.invite();
      }
    },

    async invite() {
      this.error = null
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      let emails = 0
      this.emails.forEach(email => {
        if (email !== '') {
          emails += 1
        }
      })
      if (emails === 0) {
        this.error = 'Please enter at least one email'
        return
      } else {
        this.error = null
      }
      this.loading = true
      let promises = []
      this.emails.forEach(email => {
        if (email !== '') promises.push(this.sendInvite(email))
      })
      await Promise.all(promises)
      this.loading = false
      if (this.error){
        this.error='One or more users have already been invited'
        return
      }
      /*if (this.step_3_status!==3){
        let stepData = {
          step: 3,
          status: 2,
          complete:true
        }
        this.$store.commit('updateStepStatus', stepData)
      }else if (this.step_4_status!==3){
        let stepData = {
          step: 4,
          status: 2,
          complete:true
        }
        this.$store.commit('updateStepStatus', stepData)
      }else{
        let stepData = {
          step: 2,
          status: 3,
          complete:true
        }
        this.$store.commit('updateStepStatus', stepData)
      }
      localStorage.setItem('eblitz_emails', JSON.stringify(this.emails))*/
      // this.copy_status = false
      this.emails = ['', '', '']
    },
    async sendInvite(email) {
      let params = {
        email: email,
        max_use: 1,
        date_expiration: moment().add(10, 'days').format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'),
        test_mode: false
      }
      await axios.post('/'+this.url.service_name_auth+'/'+this.url.version_number+'/'+this.url.service_name_user+'/'+'invites', params).catch(err => {
        this.error = err.response.data.message
      })
    },
    selectText(e) {
      e.target.select()
    },
    copyLink() {
      this.$copyText(this.invite_link)
      this.copy_status = true
    },
    skip(){
      if (this.step_3_status!==3){
        let stepData = {
          step: 3,
          status: 2
        }
        this.$store.commit('updateStepStatus', stepData)
      }else if (this.step_4_status!==3){
        let stepData = {
          step: 4,
          status: 2
        }
        this.$store.commit('updateStepStatus', stepData)
      }
    },
    changeStatus(status) {
      let stepData = {
        step: 2,
        status: status
      }
      this.$store.commit('updateStepStatus', stepData)
    },
  }
}
</script>

<style>
/*-------------------Copied-------------------*/
.check-sign {
  position: absolute;
  background: #fff;
}

.check-part-1 {
  width: 10px;
  height: 3px;
  transform: rotate(45deg);
  top: 23px;
  right: 28px;
}

.check-part-2 {
  width: 20px;
  height: 3px;
  transform: rotate(-45deg);
  top: 21px;
  right: 13px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
